export default "__VITE_ASSET__CfPJ2Mxm__"